/**
 * Cart-related Redux Actions
 */
/* tslint:disable:max-line-length */
import actionCreatorFactory, { Action } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Cart');

// Request Async Actions
export type RequestAddItemToCartAction = Action<IRequestAddItemToCartActionPayload>;
export type RequestRemoveItemFromCartAction = Action<IRequestRemoveItemFromCartActionPayload>;

export const requestSetCartFromLocalStorage = actionCreator('REQUEST_SET_CART_FROM_LOCAL_STORAGE');
export const requestAddItemToCart = actionCreator<IRequestAddItemToCartActionPayload>('REQUEST_ADD_ITEM_TO_CART');
export const requestRemoveItemFromCart = actionCreator<IRequestRemoveItemFromCartActionPayload>('REQUEST_REMOVE_ITEM_FROM_CART');
export const requestUpdateCartItemTerms = actionCreator<IRequestUpdateCartItemTermsActionPayload>('REQUEST_UPDATE_CART_ITEM_TERMS');

// Async Actions
export const setCartFromLocalStorage = actionCreator.async<void, ICartState>('SET_CART_FROM_LOCAL_STORAGE');
export const addItemToCart = actionCreator.async<IAddItemToCartActionPayload, ICartActionResultActionPayload>('ADD_ITEM_TO_CART');
export const removeItemFromCart = actionCreator.async<IRemoveItemFromCartActionPayload, ICartActionResultActionPayload>('REMOVE_ITEM_FROM_CART');
export const updateCartItemTerms = actionCreator.async<IUpdateCartItemTermsActionPayload, ICartActionResultActionPayload>('UPDATE_CART_ITEM_TERMS');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/cart.ts